import { render } from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "./store/index";

import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";

render(
  <Provider store={configureStore({})}>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
